import { useCallback, useEffect, useState } from "react";
import { getIntegrationSchedules } from "../../services/integrationService"
import { IntegrationSchedule } from "../../types/types";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePen } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { IntegrationActions } from "../../stateManagement/actions/integrationDashboardActions";
import { Loader } from "../../components/loader/Loader";
import Switch from "react-switch";

export default function ScheduleListPage(props: { increment: Function }) {

    const dispatch = useDispatch();

    const [allSchedules, setAllSchedules] = useState<IntegrationSchedule[]>([]);
    const [loader, setLoader] = useState<boolean>(true);

    const lob = localStorage.lob;

    const fetchIntegrationSchedules = useCallback(async () => {
        return await getIntegrationSchedules(lob);
    }, [lob])

    useEffect(() => {
        (async () => {
            setAllSchedules(await fetchIntegrationSchedules());
            setLoader(false);
        })()
    },[fetchIntegrationSchedules])

    function editIntegration(jobName: string) {
        const schedule = allSchedules.find(schedule => schedule.jobName === jobName)
        if (schedule) {
            dispatch(IntegrationActions.setIntegrationSchedule(schedule))
            props.increment();
        }
    }

    return (<>
        {loader ? <Loader /> :
            <table className="schedule-list-table">
                <thead>
                    <tr>
                        {/* <th>Customer Account</th> */}
                        <th style={{paddingLeft:"15px"}}>Job Name</th>
                        <th>Profile Name</th>
                        <th>Entity</th>
                        <th>Transformer ID</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {allSchedules.sort((a,b)=>a.jobName.localeCompare(b.jobName)).map((schedule:IntegrationSchedule) => (
                        <tr key={schedule.jobName}>
                            {/* <td align="center">{schedule.lob}</td> */}
                            <td>
                                <IconButton className="edit-schedule-btn" onClick={() => editIntegration(schedule.jobName)}>
                                    <FontAwesomeIcon icon={faSquarePen} />
                                </IconButton>
                                {schedule.jobName}
                            </td>
                            <td>{schedule.profileName}</td>
                            <td>{schedule.entityName}</td>
                            <td>{schedule.mapperName || schedule.transformerId || "N/A"}</td>
                            <td align="center" className="schedule-status-badge">
                                <Switch 
                                    onChange={()=>{}} 
                                    checked
                                    disabled={true}
                                    onColor="#24c6b1"
                                    handleDiameter={24}
                                    height={32}
                                    width={75}
                                    checkedIcon={<h6>Online</h6>}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        }
    </>)
}
